import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Optional,
  Output
} from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  NgForm
} from '@angular/forms';

import { MessagesService } from '../../messages/messages.service';

@Directive({
  selector: 'form[formSubmitValidator]'
})
export class FormSubmitValidatorDirective {
  @Output('formSubmitValidator') onSubmit = new EventEmitter<NgForm>();

  constructor(
    private el             : ElementRef<HTMLFormElement>,
    private messagesService: MessagesService,
    @Optional()
    private ngForm         : NgForm
  ) {}

  private _isPending ( control : AbstractControl ) : boolean {
    const children = ( control as FormGroup ).controls || {};

    return control.pending
      || Object.values(children).some(( child : AbstractControl ) => this._isPending(child));
  }

  @HostListener('submit', [ '$event' ])
  handleSubmit ( event : Event ) : void {
    event.preventDefault();
    event.stopPropagation();

    const control = this.ngForm.control;

    if ( !control ) {
      this.onSubmit.emit(this.ngForm);

      return;
    }

    // A submit while an async check is running is ignored, as the AngularJS valid-submit does.
    if ( this._isPending(control) ) {
      return;
    }

    control.markAllAsTouched();

    this.markAllDirty(control);

    control.updateValueAndValidity({
      onlySelf: false
    });

    if ( control.valid ) {
      this.onSubmit.emit(this.ngForm);

      return;
    }

    this.focusInvalidControl();
    this.messagesService.clientError((control as any));
  }

  focusInvalidControl () : void {
    const formElement : HTMLFormElement           = this.el.nativeElement;
    const firstInvalidControl: HTMLElement | null = formElement.querySelector('.ng-invalid');

    if ( firstInvalidControl ) {
      firstInvalidControl.scrollIntoView({
        behavior: 'smooth',
        block   : 'center'
      });

      firstInvalidControl.focus({
        preventScroll: true
      });
    }
  }

  markAllDirty ( control : AbstractControl ) : void {
    control.markAsDirty();

    const group = control as any;

    if ( group?.controls ) {
      Object.values(group.controls)
        .forEach(( ctrl : AbstractControl ) => this.markAllDirty(ctrl));
    }
  }
}
